import { useQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets/constants';
import { CAN_WRITE_PRACTITIONER_NOTE_QUERY_KEY } from './constants';

const getCanWritePractitionerNote = async (kitId: string): Promise<boolean> => {
  const response: { canWrite: boolean } | null = await API.get(
    apiName,
    `${apiBasePath}/practitioner-notes/${kitId}/can-write`,
    {},
  );

  return !!response?.canWrite;
};

// Whether the impersonating practitioner/partner may write this kit's note
export function useCanWritePractitionerNote(kitId: string | null | undefined) {
  return useQuery({
    queryKey: [CAN_WRITE_PRACTITIONER_NOTE_QUERY_KEY, kitId],
    queryFn: () => getCanWritePractitionerNote(kitId!),
    enabled: !!kitId,
  });
}
